export const STADIUM_ORDER_STATES = {
  SUBMITTED: 'submitted',
  SUBMISSION_FAILED: 'submission_failed',
  AUTHORIZATION_FAILED: 'authorization_failed',
  COMPLETED: 'completed',
  APPROVED_OFFLINE: 'approved_offline',
  CANCELLED: 'cancelled',
}

export const INTERNAL_ORDER_STATES = {
  PREAUTH: 'preauth',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
}

export const isFinalState = (state) => {
  return [
    STADIUM_ORDER_STATES.AUTHORIZATION_FAILED,
    STADIUM_ORDER_STATES.COMPLETED
  ].includes(state)
}